import { render, staticRenderFns } from "./WtEntityTable.vue?vue&type=template&id=519d2898&lang=pug&"
import script from "./WtEntityTable.vue?vue&type=script&lang=js&"
export * from "./WtEntityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports